export default __webpack_public_path__ + "static/media/icomoon.dc09315a.ttf";